import { Outlet, useLocation } from "react-router-dom";
import Footer from "../Footer/Footer";
import LightNavbar from "../Navbar/LightNavbar";
import DarkNavbar from "../Navbar/DarkNavbar";
import { useEffect } from "react";

export default function MainLayout() {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isInfoPage = location.pathname.startsWith("/info");

  return (
    <>
      {isInfoPage ? <DarkNavbar /> : <LightNavbar />}
      <Outlet />
      <Footer /> 
    </>
  );
}
